import { create } from "zustand";

const useOverlayModalStore = create((set) => ({
  isOpen: false,
  contentKey: null,
  contentProps: {},
  triggerElement: null,
  openedViaKeyboard: false,

  openOverlayModal: (contentKey, contentProps = {}, { viaKeyboard } = {}) =>
    set({
      isOpen: true,
      contentKey,
      contentProps,
      triggerElement: document.activeElement,
      openedViaKeyboard: viaKeyboard ?? false,
    }),

  closeOverlayModal: () =>
    set({
      isOpen: false,
      contentKey: null,
      contentProps: {},
      triggerElement: null,
      openedViaKeyboard: false,
    }),
}));

export const useOverlayModalIsOpen = () =>
  useOverlayModalStore((s) => s.isOpen);

export const useOpenOverlayModal = () =>
  useOverlayModalStore((s) => s.openOverlayModal);

export const useCloseOverlayModal = () =>
  useOverlayModalStore((s) => s.closeOverlayModal);

export default useOverlayModalStore;
